import React from 'react';
import { BrowserRouter as Router, Switch, Redirect } from 'react-router-dom';
import { errorHandler } from 'helpers';

import {
    OrderPage,
    OrdersPage,
    AccountPage,
    // AddressBook,
    // AddressForm,
    // SubscriptionsPage,
    ReviewPage,
    LoginPage,
    NewPasswordPage,
    NoMatch,
} from 'pages';
import { AuthRoute, PublicRoute } from 'components/Route';

const AppRouter = () => {
    errorHandler();
    return (
        <Router basename={process.env.PUBLIC_URL}>
            <Switch>
                <AuthRoute exact path={`/`}>
                    <Redirect to="/orders" />
                </AuthRoute>
                <AuthRoute exact path={`/orders`}>
                    <OrdersPage />
                </AuthRoute>
                <AuthRoute path="/orders/page/:id">
                    <OrdersPage />
                </AuthRoute>
                <AuthRoute path="/orders/:id">
                    <OrderPage />
                </AuthRoute>
                <AuthRoute path="/settings">
                    <AccountPage />
                </AuthRoute>
                {
                    //<AuthRoute path="/addressBook/add">
                    //     <AddressForm mode="add" />
                    // </AuthRoute>
                    // <AuthRoute path="/addressBook/edit/:id">
                    //     <AddressForm mode="edit" />
                    // </AuthRoute>
                    // <AuthRoute path="/addressBook">
                    //     <AddressBook />
                    // </AuthRoute>
                }
                {
                    // <AuthRoute path="/subscriptions">
                    //<SubscriptionsPage />
                    // </AuthRoute>
                }
                <AuthRoute path="/review/:id">
                    <ReviewPage />
                </AuthRoute>
                <AuthRoute exact path="/review">
                    <ReviewPage />
                </AuthRoute>
                <PublicRoute path={`/login`}>
                    <LoginPage />
                </PublicRoute>
                <PublicRoute path="/changePassword/:token">
                    <NewPasswordPage />
                </PublicRoute>
                <PublicRoute path={`/logout`}>
                    <Redirect to="/login" />
                </PublicRoute>
                <PublicRoute path="*">
                    <NoMatch />
                </PublicRoute>
            </Switch>
        </Router>
    );
};

export default AppRouter;
